import Button from 'components/base/Button';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import MedicoForm from 'components/forms/MedicoForm';
import { SalvarMedicoDTO, useSalvarMedico } from 'hooks/useMedicos';
import { Navigate } from 'react-router-dom';
import { Form } from 'react-bootstrap';
import { SubmitHandler } from 'react-hook-form';

const NovoMedico = () => {
    const { mutate, isSuccess, isPending } = useSalvarMedico();

    const handleSubmit: SubmitHandler<SalvarMedicoDTO> = data => {
        mutate(data);
    };

    if (isSuccess) {
        return <Navigate to="/cadastros/medicos" />;
    }

    return (
        <div>
            <PageBreadcrumb
                items={[
                    { label: 'Retaguarda', url: '/retaguarda' },
                    { label: 'Médicos', url: '/cadastros/medicos' },
                    { label: 'Novo Médico', active: true }
                ]}
            />
            <div className="d-flex flex-wrap gap-3 flex-between-end mb-5">
                <div>
                    <h2 className="mb-2">Cadastrar Novo Médico</h2>
                    <h5 className="text-body-tertiary fw-semibold">
                        Preencha as informações para cadastrar um novo médico
                    </h5>
                </div>
                <div className="d-flex flex-wrap gap-2">
                    <Button variant="phoenix-secondary" type="button">
                        Descartar
                    </Button>
                    <Button
                        variant="primary"
                        type="submit"
                        form="medico-form"
                        loading={isPending}
                        disabled={isPending}
                        loadingPosition="start"
                    >
                        Salvar
                    </Button>
                </div>
            </div>
            <MedicoForm
                id="medico-form"
                onSubmit={handleSubmit}
                isSubmitting={isPending}
            />
        </div>
    );
};

export default NovoMedico; 